export const privacyPageUrl = 'https://go.microsoft.com/fwlink/?LinkId=521839';
export const MAX_SUBJ_LENGTH = 128;
export const YES = 'Yes';
export const NO = 'No';
export const OK = 'OK';
export const NOTNOW = 'Not now';

// ODS endpoint to create a diagnostics session
export const ODSDIAGNOSTICSESSIONENDPOINT =
    'https://api.diagnostics.office.com/v1/diagnosticsession';

// ODS endpoint to add diagnostics to a diagnostics session
export const ODSDIAGNOSISENDPOINT = 'https://api.diagnostics.office.com/v1/diagnosis';
export const ODSCLIENTNAME = 'OWA';
export const ODSSYMPTOMNAME = 'Feedback';
export const MSATOKENSCOPE = 'Diagnostics.ReadWrite';
export const ODSCOMPLIANCECLASSIFICATION = 'Identifiable';
export const ODSJSONPAYLOADNAME = 'DonationJson';
export const NOCATEGORYSELECTED = 'No Category Selected';
